import { render, staticRenderFns } from "./ProfileCreationError.vue?vue&type=template&id=8a069e50&scoped=true&"
import script from "./ProfileCreationError.vue?vue&type=script&lang=js&"
export * from "./ProfileCreationError.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCreationError.vue?vue&type=style&index=0&id=8a069e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a069e50",
  null
  
)

export default component.exports